import { Typography, YStack } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import { type ReactElement, type ReactNode, useId } from 'react'

interface ExportDrawerSectionProps {
  children: ReactNode
  title: string
}

export const ExportDrawerSection = ({ children, title }: ExportDrawerSectionProps): ReactElement => {
  const titleId = useId()

  return (
    <YStack aria-labelledby={titleId} gap={8} role="group">
      <Typography.Text color={colors.content.neutral.medium} id={titleId} size="medium">
        {title}
      </Typography.Text>
      {children}
    </YStack>
  )
}
